"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    DEFAULT_TIMEOUT: true
};
exports.DEFAULT_TIMEOUT = void 0;
var _contentTypes = require("./contentTypes");
Object.keys(_contentTypes).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _contentTypes[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _contentTypes[key];
        }
    });
});
var _headers = require("./headers");
Object.keys(_headers).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _headers[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _headers[key];
        }
    });
});
var _statusCodes = require("./statusCodes");
Object.keys(_statusCodes).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _statusCodes[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _statusCodes[key];
        }
    });
});
var DEFAULT_TIMEOUT = exports.DEFAULT_TIMEOUT = 5000; //# sourceMappingURL=index.js.map
